export default __webpack_public_path__ + "static/media/100_19503.51a9d0ad.jpg";